const e = (r) => ({
  src: r.properties?.link[0].url,
  ratio: 1.7777777777777777
});
export {
  e as mediaDeliveryApiParser
};
